import script from "./ManifDepartamentoHybridPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ManifDepartamentoHybridPage.vue?vue&type=script&setup=true&lang=js"

import "./ManifDepartamentoHybridPage.vue?vue&type=style&index=0&id=86cdd766&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86cdd766"]])

export default __exports__